import OpenBanking from './views/main';

export default OpenBanking;
